"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userPreferencesDefaultValue = exports.userPreferencesSchema = void 0;
const zod_1 = require("zod");
exports.userPreferencesSchema = zod_1.z.object({
    selectedDate: zod_1.z.string(),
    hideAmounts: zod_1.z.boolean(),
    menuOpened: zod_1.z.boolean(),
    hideLogo: zod_1.z.boolean().optional(),
    hideLogout: zod_1.z.boolean().optional(),
    outside_plan: zod_1.z
        .object({
        page: zod_1.z.enum(['sources', 'calc', 'graph']),
        calc_tab: zod_1.z.number(),
        source_tab: zod_1.z.number(),
    })
        .partial()
        .optional(),
    plans: zod_1.z
        .record(zod_1.z.string(), zod_1.z
        .object({
        page: zod_1.z.enum(['sources', 'calc', 'statement', 'graph']),
        calc_tab: zod_1.z.number(),
        source_tab: zod_1.z.number(),
        selected_statement: zod_1.z.number(),
        selected_dashboard_user: zod_1.z.string(),
    })
        .partial())
        .optional(),
    has_seen_feature: zod_1.z
        .object({})
        .optional(),
});
const defaultValue = {
    hideAmounts: false,
    hideLogo: false,
    hideLogout: false,
    menuOpened: true,
    selectedDate: '2022-01-01',
    plans: {},
    has_seen_feature: {
        source_tabs_new_location: false,
        plan_periods_changed_order: false,
        payroll_report: false,
    },
};
exports.userPreferencesDefaultValue = JSON.stringify(defaultValue, null, '\t');
